import { Box } from '@mui/material';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../exo/ExoForm';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import Loader from '../special/Loader';
import { useState } from 'react';
import Cookies from 'universal-cookie';
import moment from 'moment';

const NewEmptyProject = ({ onClose, onCreate, startDataCollection }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const cookies = new Cookies();
  const userId = cookies.get('userId');

  const fields = [
    {
      label: t('Image'),
      type: 'image',
      key: 'image',
      colspan: 2,
    },

    {
      label: t('Project Name'),
      type: 'text',
      key: 'name',
      colspan: 2,
    },
    {
      label: `${t('Customer Identifier')}`,
      type: 'text',
      key: 'externalNr',
    },
    {
      label: `${t('Prefix')}`,
      type: 'text',
      key: 'prefix',
    },
    {
      label: t('Preset'),
      type: 'projectPreset',
      key: 'preset',
      colspan: 2,
      hidden: Boolean(startDataCollection?.id),
    },
    {
      label: t('Network Storage'),
      type: 'networkStorage',
      key: 'networkStorage',
    },

    {
      label: t('Supervisor'),
      type: 'user',
      key: 'supervisor',
    },
    {
      label: t('Address'),
      type: 'address',
      key: 'address',
      colspan: 2,
      suggestionsArr: [
        {
          key: 'participants',
          isArray: true,
          type: 'participant',
        },
        {
          key: 'client',
          isArray: false,
          type: 'client',
        },
      ],
    },
    {
      label: t('Project Participants'),
      key: 'participants',
      type: 'participantsAutoComplete',
      searchParams: ['person_leads', 'company_leads'],
      colspan: 2,
      suggestionsArr: [
        {
          key: 'client',
          isArray: false,
          type: 'client',
        },
      ],
    },
    {
      label: t('Client'),
      type: 'client',
      key: 'client',
      colspan: 2,
    },
    {
      label: t('Start Date'),
      type: 'date',
      value: 'today',
      key: 'startDate',
    },

    {
      label: `${t('Deadline')}`,
      type: 'date',
      key: 'deadline',
    },
  ];
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t('Project Name is required')),
    supervisor: Yup.object().shape({
      id: Yup.string().required(t('Supervisor is required')),
    }),
    startDate: Yup.string().required(t('Start Date is required')),
    clientType: Yup.string().required(t('Client Type is required')),
    client: Yup.mixed().when('clientType', {
      is: (value) => value === 'contact' || value === 'company',
      then: (schema) =>
        Yup.object().shape({
          id: Yup.string().required(t('Supervisor is required')),
        }),
      otherwise: (schema) => Yup.object().nullable(),
    }),
    networkStorage: Yup.string().required(t('Is required')),
  });
  const config = useConfig();
  function handleSubmit(data) {
    const isUpdate = Boolean(startDataCollection && startDataCollection.id);

    DBRequest({
      config,
      path: isUpdate ? `projects/${startDataCollection.id}` : `projects`,
      method: isUpdate ? API_PATCH(data) : API_POST({ ...data, status: 0 }),
      onResponse: handleCreate,
      onLoading: setIsLoading,
    });
  }

  function handleCreate(data) {
    onClose();
    onCreate(data.data);
  }

  return (
    <Box
      className="p-2 mx-auto"
      sx={{
        width: '620px',
        maxWidth: '100%',
      }}
    >
      <Loader active={isLoading} />
      <ExoForm
        header={
          startDataCollection ? t('Update Project') : t('New Empty Project')
        }
        fields={fields}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        onCancel={onClose}
        startDataCollection={
          startDataCollection || {
            status: 0,
            clientType: 'internal',
            networkStorage: config?.project.defaultNetworkStorage,
            supervisor: { id: userId },
            startDate: moment().format('YYYY-MM-DD'),
          }
        }
        className="grid grid-cols-2 gap-4 py-4 px-3"
        noDifferences
      />
    </Box>
  );
};

export default NewEmptyProject;
